/**
 * Persist BTR event data only when an authenticated user and stable profile ID
 * have already produced a non-empty, user-namespaced storage identity.
 * A missing identity must never create the literal "..._null" shared key.
 */
export function persistBtrEventsForProfile<T>(
  profileStorageId: string | null | undefined,
  events: T[],
  storage?: Pick<Storage, 'setItem'>
): boolean {
  if (typeof profileStorageId !== 'string' || profileStorageId.trim().length === 0) {
    return false;
  }

  try {
    const targetStorage = storage ?? localStorage;
    targetStorage.setItem(`astroveda_btr_events_${profileStorageId}`, JSON.stringify(events));
    return true;
  } catch {
    // Storage may be unavailable or disabled; BTR event capture must remain usable
    // in memory without falling back to a shared or unscoped persistence key.
    return false;
  }
}
